import { useState } from "react";
import { uploadImage } from "../../utils/uploadImage";

interface ServiceImageUploadProps {
  imageUrl: string;
  onImageChange: (url: string) => void;
}

function ServiceImageUpload({ imageUrl, onImageChange }: ServiceImageUploadProps) {
  const [uploadError, setUploadError] = useState<string | null>(null);
  const [uploading, setUploading] = useState(false);

  const handleUpload = async (file: File) => {
    setUploadError(null);
    setUploading(true);
    try {
      const url = await uploadImage(file);
      onImageChange(url);
    } catch (err) {
      setUploadError(err instanceof Error ? err.message : "Upload failed");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="admin-image-uploads">
      <h3 className="h2-text" style={{ marginBottom: 16 }}>
        Service photo
      </h3>
      <p className="body-text" style={{ marginBottom: 16 }}>
        Upload a photo for this service.
      </p>

      <div className="admin-image-uploads__grid">
        <div className="admin-image-upload">
          <label className="body-text" htmlFor="service-image">
            Photo
          </label>
          {imageUrl && (
            <img src={imageUrl} alt="Service preview" className="admin-image-upload__preview" />
          )}
          <input
            id="service-image"
            type="file"
            accept="image/*"
            disabled={uploading}
            onChange={(e) => {
              const file = e.target.files?.[0];
              if (file) handleUpload(file);
              e.target.value = "";
            }}
          />
          {imageUrl && (
            <button
              type="button"
              className="admin-btn admin-btn--danger"
              onClick={() => onImageChange("")}
            >
              Remove
            </button>
          )}
        </div>
      </div>

      {uploading && <p className="body-text">Uploading photo...</p>}
      {uploadError && <p className="admin-error">{uploadError}</p>}
    </div>
  );
}

export default ServiceImageUpload;
